import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React hook; scrolls the viewport to the top when address bar location changes
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};
